export enum RolesTypeEnum {
  MASAR = 'masar',
  ITIMAD = 'itimad',
}

export enum MasarRolesEnum {
  MASAR_REVIEWER = 'MASAR_REVIEWER',
  MASAR_TEAM_LEADER = 'MASAR_TEAM_LEADER',
  MASAR_MEMBER = 'MASAR_MEMBER',
  TRAINEE_MEMBER = 'TRAINEE_MEMBER',
}
